<template>
  <div id="Exchange" @click.stop>
    <div class="discount" v-if="!courseInfo.activity && exchangeList_a.length">
      <div class="discountType">
        <a-checkbox v-model:checked="checked_b">使用兑换券</a-checkbox>
        <span v-show="!checked_b" @click="checked_b = true">
          <template v-if="!checked_b && actualPayment === 0">
            <i>不使用兑换券</i>
          </template>
          <template v-else>
            {{exchangeList_a.length}}个兑换券可用
          </template>
        </span>
        <ExchangeSelect
                v-if="checked_b"
                :options="exchangeList_a"
                :sectionList="sectionList"
                v-model:checked_b="checked_b"/>
      </div>
    </div>
  </div>
</template>
<script>
  import {Checkbox,Modal} from 'ant-design-vue';
  import ExchangeSelect from '@c/pay/ExchangeSelect.vue';
  export default {
    name:'Discount',
    components:{
      [Checkbox.name]: Checkbox,
      ExchangeSelect,
    },
    props:['courseInfo','exchangeList_a','convertibilityChecked_b','sectionList','actualPayment','couponChecked_b'],
    data(){
      return {
        checked_b: this.convertibilityChecked_b, // 是否使用优惠券
      }
    },
    inject:['convertibilityNum_fn'],
    methods:{
      // modal
      modal_fn(){
        Modal.warning({
          title: '提示',
          content: '目前已经是最优惠了',
          centered: true,
        });
      }
    },
    watch:{
      'checked_b':{
        handler(n){
          // 是否选择
          if(!n){
            this.convertibilityNum_fn();
          }
          this.$emit('update:convertibilityChecked_b', n)
        },
        deep: true
      },
      'convertibilityChecked_b':{
        handler(n){
          this.checked_b = n;
        },
        deep:true,
      }
    }
  }
</script>
<style scoped lang="scss">
  /*优惠券*/
  .discount {
    padding: 12px 20px;
    background: #FBFBFB;
    margin: 10px 0 0;
    border-radius: 6px;

    .discountType {
      display: flex;
      align-items: center;
      justify-content: space-between;
      user-select: none;

      span {
        color: $theme_blue;
        line-height: 36px;

        i{
          color: #666;
        }
      }

      .ant-checkbox-wrapper {
        flex: 0 0 auto;

        span {
          font-size: 14px;
          color: $theme_blue;
          cursor: pointer;
        }
      }
    }

    .coupon {
      display: flex;
      flex-direction: column;
      background: #fff;
      padding: 0 22px;
      line-height: 36px;
      border-radius: 6px;
      font-size: 16px;
      transition-property: height, margin-top, opacity;
      transition-duration: .3s, .3s, 0s;
      opacity: 0;
      height: 0;
      overflow: hidden;
      margin-top: 0;

      &.active {
        height: 36px;
        margin-top: 18px;
        opacity: 1;
        transition-property: height, margin-top, opacity;
        transition-duration: .3s, .3s, 1s;
      }

      li {
        display: flex;
        align-items: center;
        justify-content: space-between;

        i {
          color: #F76B03;
        }
      }
    }
  }
</style>
